import React, { useContext, useCallback, useState } from 'react';
import Ledger from '../HDWallets/Ledger';
import Trezor from '../HDWallets/Trezor';
import CloseIcon from '../Icons/CloseIcon';
import ArrowIcon from '../Icons/ArrowIcon';
import WalletProviders from '../WalletProviders';
import { Context } from '../../stateManagement/store';
import { callbackEventProvider } from "../../services/EventObserver";
import useActionsHook from '../../stateManagement/actions';
import NotSupported from '../NotSupported';
import EventTypes from "../../constants/eventTypes";

const NotConnected = () => {
  const { dispatch, state } = useContext(Context);

  const actions = useActionsHook(dispatch);

  const handleClick = useCallback(() => {
    actions.closeModal();
  }, [actions]);

  const handleAfterConnect = useCallback(() => {
    callbackEventProvider.emit(EventTypes.AFTER_CONNECT, null);
  }, []);

  const handleConnectClick = useCallback(async (connectionType) => {
    await actions.connectWallet({ connectionType, ...(state.network || {}) });
    handleAfterConnect();
  }, [actions, state.network, handleAfterConnect]);

  const {
    isLedgerModalOpen, connectingWallet, connectingWalletType, connectionError, isTrezorModalOpen,
  } = state;

  const [more, setMore] = useState(false);
  const toggleMore = useCallback(() => setMore(!more), [more]);

  if (isLedgerModalOpen) {
    return <Ledger afterConnect={handleAfterConnect} />;
  }

  if (isTrezorModalOpen) {
    return <Trezor afterConnect={handleAfterConnect} />;
  }

  return (
    <>
      <div className="web3-wc_modal_header">
        {more && <ArrowIcon className="web3-wc_modal-icon-btn web3-wc_back-modal-btn" onClick={toggleMore} />}
        <CloseIcon className="web3-wc_modal-icon-btn web3-wc_close-modal-btn" onClick={handleClick} />
        <h3>Connect Wallet</h3>
      </div>
      {more ? (
        <NotSupported />
      ) : (
        <>
          <WalletProviders
            handleConnect={handleConnectClick}
            connecting={connectingWallet && connectingWalletType}
          />
          {!!connectionError && <div className="web3-wc_connection-error">{connectionError}</div> }
          <div className="web3-wc_modal_footer">
            <div className="web3-wc_show_more">
              <a onClick={toggleMore}>Show More +</a>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default NotConnected;
